import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
import { CVService } from "../../../../../service/CVService";
import { useToastStore } from "../../../../../stores/toastStore";
import { TYPE_NOTIFICATION } from "../../../shares/NotificationBull";
import { useQuery } from "../../../../../hooks/useQuery";
import AppFileImput from "../../../shares/AppFileImput";
import { uploadService } from "../../../../../service/UploadService";
import { enleverBaliseHtml } from "../../../../../Helpers/utilsHelper";
import { CVFormationService } from "../../../../../service/CVFormationService";
import StandardSkeletoon from "../../../shares/loader/StandardSkeletoon";
const INIT_FORMATION = {
  date_debut: null,
  date_fin: null,
  domaine_formation: null,
  theme_formation: null,
  fid: null,
  autres: null,
  certificat: null,
};

const INIT_FORM_ERROR = {
  date_debut_error: null,
  date_fin_error: null,
  domaine_formation_error: null,
  theme_formation_error: null,
  fid_error: null,
  autre_error: null,
  certificat_error: null,
};
const FormationForm = ({ open, onFormClose, onFormOpen, idFormation }) => {
  const [currentFormation, setCurrentFormation] = useState(INIT_FORMATION);
  const [isSubmited, setIsSubmited] = useState(false);
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const [formLoading, setFormLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const showToastStore = useToastStore((state) => state.showToast);
  const [selectedFile, setSelectedFile] = useState(null);
  const query = useQuery();
  const id_ext_user = query.get("ref");
  const handleFormClose = () => {
    onFormClose();
    handleInitAll();
  };

  const handleFileUpload = (file) => {
    setFormErrors({
      ...formErrors,
      certificat_error: "Telechargement du fichier en cours...",
    });
    uploadService.uploadFile(file).then((res) => {
      if (!(res && res.success)) {
        showToastStore(TYPE_NOTIFICATION.ERROR, enleverBaliseHtml(res.error));
      }
      setCurrentFormation({
        ...currentFormation,
        certificat: res && res.success ? res.data.file_name : null,
      });
      setFormErrors({
        ...formErrors,
        certificat_error:
          res && res.success ? null : enleverBaliseHtml(res.error),
      });
    });
  };

  useEffect(() => {
    if (selectedFile) {
      handleFileUpload(selectedFile);
    }
  }, [selectedFile]);

  const handleChangeFormationData = (event) => {
    const { name, value } = event.target;
    setCurrentFormation({ ...currentFormation, [name]: value });
  };

  const handleInitAll = () => {
    setCurrentFormation(INIT_FORMATION);
    setFormErrors(INIT_FORM_ERROR);
    setIsSubmited(false);
  };

  const handleCheckError = () => {
    let end_date_is_less_than_start_date =
      new Date(currentFormation.date_debut) >
      new Date(currentFormation.date_debut);
    setFormErrors({
      date_debut_error: currentFormation.date_debut
        ? null
        : "date de debut est requis",
      date_fin_error: currentFormation.date_fin
        ? end_date_is_less_than_start_date
          ? "date de fin doit etre apres la date de debut"
          : null
        : "date de fin est requis",
      domaine_formation_error: !currentFormation.domaine_formation
        ? "domaine_formation est requis"
        : null,
      theme_formation_error: !currentFormation.theme_formation
        ? "Theme est requis"
        : null,
      fid_error:
        !currentFormation.fid && !currentFormation.autres
          ? "Fid ou Autre est requis"
          : null,
      autres_error:
        !currentFormation.fid && !currentFormation.autres
          ? "Fid ou Autre est requis"
          : null,
      certificat_error: null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  const handleFetchCurrentFormation = () => {
    setFormLoading(true);
    CVFormationService.find_by_id(idFormation)
      .then((res) => {
        if (res.data) {
          setCurrentFormation(res.data);
        } else {
          showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
        }
      })
      .finally(() => {
        setFormLoading(false);
      });
  };

  const getInsertableFormation = () => {
    return {
      ...currentFormation,
      date_debut: currentFormation.date_debut,
      date_fin: currentFormation.date_fin,
      domaine_formation: currentFormation.domaine_formation,
      theme_formation: currentFormation.theme_formation,
      fid: currentFormation.fid || "",
      autres: currentFormation.autres || "",
      certificat: currentFormation.certificat || "",
    };
  };

  const handleInsertFormation = () => {
    const isValid = handleCheckError();
    if (isValid) {
      setSubmitting(true);
      const formationData = getInsertableFormation();
      formationData.id_ext_user = id_ext_user;
      CVFormationService.insert(formationData)
        .then((res) => {
          if (res.success) {
            showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleFormClose();
          } else {
            showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      showToastStore(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };
  const handleUpdateFormation = () => {
    const isValid = handleCheckError();
    if (isValid) {
      setSubmitting(true);
      let formationData = getInsertableFormation();
      CVFormationService.update(formationData)
        .then((res) => {
          if (res.success) {
            showToastStore(TYPE_NOTIFICATION.SUCCESS, res.message);
            handleFormClose();
          } else {
            showToastStore(TYPE_NOTIFICATION.ERROR, res.message);
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      showToastStore(TYPE_NOTIFICATION.ERROR, "Veuillez verifier les champs");
    }
  };

  const handleSubmit = () => {
    setIsSubmited(true);
    if (idFormation) {
      handleUpdateFormation();
    } else {
      handleInsertFormation();
    }
  };

  useEffect(() => {
    if (idFormation && open) handleFetchCurrentFormation();
  }, [open, idFormation]);

  useEffect(() => {
    handleCheckError();
  }, [currentFormation]);

  return (
    <>
      <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
        <Paper sx={{ m: 3 }} elevation={0}>
          <StandardSkeletoon show={formLoading} escalier row={3} />
          <Grid display={formLoading ? "none" : ""}>
            <CardHeader title="Formation" />
            <CardContent>
              <Grid container>
                <FormControl fullWidth>
                  <label>Date debut *</label>
                  <TextField
                    id="date_debut"
                    name="date_debut"
                    onChange={handleChangeFormationData}
                    size="small"
                    type="date"
                    placeholder="Debut debut de la formation"
                    fullWidth
                    sx={{
                      "& input": {
                        textAlign: "right",
                      },
                    }}
                    value={currentFormation.date_debut}
                    error={formErrors.date_debut_error && isSubmited}
                    helperText={isSubmited ? formErrors.date_debut_error : ""}
                    aria-describedby="nom_helper"
                  />
                  <FormHelperText id="nom_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Date fin *</label>
                  <TextField
                    id="date_fin"
                    name="date_fin"
                    onChange={handleChangeFormationData}
                    size="small"
                    type="date"
                    placeholder="Fin de formation"
                    fullWidth
                    sx={{
                      "& input": {
                        textAlign: "right",
                      },
                    }}
                    value={currentFormation.date_fin}
                    error={formErrors.date_fin_error && isSubmited}
                    helperText={isSubmited ? formErrors.date_fin_error : ""}
                    aria-describedby="nom_helper"
                  />
                  <FormHelperText id="nom_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Domaine *</label>
                  <TextField
                    id="domaine_formation"
                    name="domaine_formation"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Domaine de formation"
                    fullWidth
                    value={currentFormation.domaine_formation}
                    error={formErrors.domaine_formation_error && isSubmited}
                    helperText={
                      isSubmited ? formErrors.domaine_formation_error : ""
                    }
                    aria-describedby="domaine_formation_helper"
                  />
                  <FormHelperText id="domaine_formation_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Theme de formation *</label>
                  <TextField
                    id="theme_formation"
                    name="theme_formation"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Theme de formation"
                    fullWidth
                    value={currentFormation.theme_formation}
                    error={formErrors.theme_formation_error && isSubmited}
                    helperText={
                      isSubmited ? formErrors.theme_formation_error : ""
                    }
                    aria-describedby="theme_formation_helper"
                  />
                  <FormHelperText id="theme_formation_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Fid</label>
                  <TextField
                    id="fid"
                    name="fid"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Formation FID"
                    fullWidth
                    value={currentFormation.fid}
                    error={formErrors.fid_error && isSubmited}
                    helperText={isSubmited ? formErrors.fid_error : ""}
                    aria-describedby="fid_helper"
                  />
                  <FormHelperText id="fid_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Autre</label>
                  <TextField
                    id="autres"
                    name="autres"
                    onChange={handleChangeFormationData}
                    size="small"
                    placeholder="Autres formation"
                    fullWidth
                    value={currentFormation.autres}
                    error={formErrors.autres_error && isSubmited}
                    helperText={isSubmited ? formErrors.autres_error : ""}
                    aria-describedby="autres_helper"
                  />
                  <FormHelperText id="autres_helper"></FormHelperText>
                </FormControl>
                <FormControl fullWidth>
                  <label>Certificat</label>
                  <AppFileImput
                    name="certificat"
                    placeholder={"Certificat"}
                    handleFileUpload={(evt) => {
                      handleChangeFormationData({
                        target: {
                          name: "certificat",
                          value: evt.target.files[0]?.name || "",
                        },
                      });
                      setSelectedFile(evt.target.files[0]);
                    }}
                    handleClearFile={(evt) => {
                      handleChangeFormationData({
                        target: {
                          name: "certificat",
                          value: null,
                        },
                      });
                      setSelectedFile(null);
                    }}
                    file_name={currentFormation.certificat || ""}
                    allowedFIle={".jpeg,.jpg,.png,.pdf,.docx"}
                    error={formErrors.certificat_error}
                    helperText={formErrors.certificat_error}
                  />
                  <FormHelperText id="certificat_helper"></FormHelperText>
                </FormControl>
              </Grid>
            </CardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
              <AppButton
                loading={submitting}
                text={"Enregistrer"}
                variant={"contained"}
                size={"medium"}
                onClick={handleSubmit}
              />
              <AppButton
                text={"Fermer"}
                variant={"outlined"}
                size={"medium"}
                onClick={handleFormClose}
              />
            </CardActions>
          </Grid>
        </Paper>
      </Dialog>
    </>
  );
};

export default FormationForm;
